import { useState } from 'react';
import { gt } from 'semver';
import { useChangelogData } from './useChangelogData';

export const useChangelogVisibilityOptions = ({ initialOpened }: { initialOpened?: boolean } = {}) => {
  const { storedVersion, latestWhatIsNewVersion } = useChangelogData();
  return useState(initialOpened ?? Boolean(storedVersion && gt(latestWhatIsNewVersion, storedVersion)));
};
